import React, { useEffect, useRef, useState } from "react";
import LeftIcon from "../../images/LeftIcon";
import DatePicker from "react-datepicker";
import {
  reloadHeader,
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
} from "../../services/navigate.service";
import { createSales } from "../../services/sales.service";
import {
  validateEmail,
  validateNoSpecialChars,
  validateNoSpecialCharsOrSpaces,
  validateOnlyNumbers,
  validateOnlyNumbersNotThree,
  validatePhoneNumber,
} from "../../validation/ValidationInput";
import PopupLocation from "../../components/PopupLocation";
import BackIcon from "../../images/BackIcon";
import UploadIconV2 from "../../images/UploadIconV2";
import {
  createLanguage,
  loadDetailLanguage,
  updatdeLanguage,
} from "../../services/language.services";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import UploadIcon from "../../images/UploadIcon";
import PhotoIcon from "../../images/PhotoIcon";
import { useResponsive } from "../../hook/useResponsive";
interface InforTable {
  title: string;
  path: string;
  desc: string;
  titleCreate: string;
}

interface Country {
  id: string;
  code: string;
  name: string;
}

const CreateLanguage = () => {
  const preLanguage = localStorage.getItem("language");
  const [formValues, setFormValues] = useState<any>({
    code: "",
    name: "",
  });
  const { isMobile, getWidth } = useResponsive();
  const userId: string = localStorage.getItem("userId") || "";
  const [fileName, setFileName] = useState("");
  const [base64Image, setBase64Image] = useState<any>("");
  const [language, setLanguage] = useState<any>(null);
  const [errors, setErrors] = useState<any>({});
  const limits = useFieldLimits(coreFormLimits("language"));
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isDragging, setIsDragging] = useState(false);

  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 50,
    sort: "DESC",
  });
  const path = window.location.pathname;
  const id: string = path.split("/").pop() || "";
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [path]);
  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await loadDetailLanguage(id);
      setFormValues(response.data);
      setFileName(response.data.icon);
      setBase64Image(response.data.icon);
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        setFileName(file.name);
        setBase64Image(base64Image);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please upload an image file.");
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = reader.result as string;
        setFileName(file.name);
        setBase64Image(base64);
      };

      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid image file.");
    }
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits({ ...formValues, icon: base64Image }, limits, language, ["code", "name", "icon"]);
    if (!formValues.code) {
      newErrors.code = "Code is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    webLoadingTrue();
    try {
      const payload: any = {
        ...formValues,
        icon: base64Image,
        userId,
      };
      if (id !== "new") {
        const response: any = await updatdeLanguage(id, payload);
        showToast({
          message: "Language Updated !",
          type: "success",
          duration: 20000,
        });
      } else {
        const response: any = await createLanguage(payload);
        showToast({
          message: "Language Created !",
          type: "success",
          duration: 20000,
        });
      }
      webLoadingFalse();
      webNavigate("/" + preLanguage + "/languages" + "?tab=Languages");
    } catch (error: any) {
      setShowPopup(true);
      webNavigate("/" + preLanguage + "/languages" + "?tab=Languages");
      webLoadingFalse();
      showApiError(error, { language, setFieldErrors: setErrors });
    }
  };

  const handleReceivePageNumber = (pageNumber: number) => {
    setFilter({ ...filter, page: pageNumber });
  };

  return (
    <>
      <div className="bg-white">
        <div className="flex items-center ">
          <div
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate("/" + preLanguage + "/languages" + "?tab=Languages");
            }}
          >
            <BackIcon />
          </div>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Back"] ? language?.["Back"] : "Back"}
          </p>
        </div>
      </div>
      {id === "new" ? (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Add language`]
            ? language?.[`Add language`]
            : `Add language`}
        </p>
      ) : (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Edit language`]
            ? language?.[`Edit language`]
            : `Edit language`}
        </p>
      )}
      {/* <div className="flex items-center" style={{ marginTop: "24px", borderBottom: "1px solid #DEDEE2" }}>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("profile") }}
                    style={tab === "profile" ? { marginRight: "24px", color: "#078D91", borderBottom: "1px solid #078D91" } : { marginRight: "24px", color: "#767685", borderBottom: "1px solid transparent" }} >Profile</p>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("invoices") }}
                    style={tab === "invoices" ? { color: "#078D91", borderBottom: "1px solid #078D91" } : { color: "#767685", borderBottom: "1px solid transparent" }} >Invoices</p>
            </div> */}
      <div style={{ height: "calc(100% - 163px)" }}>
        <>
          <form>
            <div
              className="flex items-center"
              style={{ gap: "24px", flexWrap: "wrap" }}
            >
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Code"]
                      ? language?.["Code"]
                      : "Code"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={1}
                    value={formValues?.code}
                    name="code"
                    {...limitProps(limits, "code")}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.code} max={limits.code?.maxLength} />
                </div>
                {errors.code && <p className="error">{errors.code}</p>}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Language"]
                      ? language?.["Language"]
                      : "Language"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    value={formValues?.name}
                    tabIndex={2}
                    onKeyDown={validateNoSpecialChars}
                    name="name"
                    {...limitProps(limits, "name")}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.name} max={limits.name?.maxLength} />
                </div>
                {errors.name && <p className="error">{errors.name}</p>}
              </div>

              <div className="" style={{ width: "100%" }}>
                <div>
                  <div className="flex items-center justify-between">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["Flag icon"]
                        ? language?.["Flag icon"]
                        : "Flag icon"}
                    </p>
                  </div>
                  <div
                    className="lg:flex items-center"
                    style={{ gap: "16px", marginTop: "12px" }}
                  >
                    <div
                      className="flex items-center justify-center"
                      style={{
                        width: "84px",
                        height: "84px",
                        borderRadius: "72px",
                        backgroundColor: "#EBF0F0",
                      }}
                    >
                      <div className="w-6 h-6 flex items-center justify-center">
                        {formValues?.icon ? (
                          <img
                            src={formValues?.icon}
                            alt="Uploaded Preview"
                            style={{ height: "24px", objectFit: "contain" }}
                          />
                        ) : (
                          <PhotoIcon />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex items-center justify-center"
                      style={{
                        padding: "20px",
                        border: `1px dashed ${isDragging ? "#3AC0C4" : "#DBE4E4"}`,
                        borderRadius: "16px",
                        width: isMobile ? "100%" : "calc(100% - 100px)",
                        marginTop: isMobile ? "12px" : "0px",
                      }}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                    >
                      <div className="space-y-2 text-center">
                        <div className="flex items-center justify-center">
                          <UploadIcon />
                        </div>
                        <p className="text-[14px] text-main leading-[20px] font-inter font-medium">
                          {language &&
                            language?.["Drag and drop your logo here"]
                            ? language?.["Drag and drop your logo here"]
                            : "Drag and drop your logo here"}
                        </p>
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#819596",
                            marginBottom: "8px",
                          }}
                          className=" text-main leading-[20px] font-inter"
                        >
                          {language && language?.["OR"]
                            ? language?.["OR"]
                            : "OR"}
                        </p>
                        <label
                          htmlFor="fileInput"
                          className="text-[14px] font-inter font-semibold leading-[18px] cursor-pointer"
                          style={{
                            color: "#0F7679",
                            padding: "8px 16px",
                            border: "1px solid #C9D7D8",
                            borderRadius: "30px",
                          }}
                        >
                          {language && language?.["Browse file"]
                            ? language?.["Browse file"]
                            : "Browse file"}
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                          id="fileInput"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.icon && <p className="error">{errors.icon}</p>}
                </div>
              </div>
            </div>
          </form>
          <PopupLocation
            show={showPopup}
            title={`${id === "new" ? (language && language?.["Create Location"] ? language?.["Create Location"] : "Create Location") : language && language?.["Update Location"] ? language?.["Update Location"] : "Update Location"}`}
            desc={`${id === "new" ? (language && language?.["Create Location Failed"] ? language?.["Create Location Failed"] : "Create Location Failed") : language && language?.["Update Location Failed"] ? language?.["Update Location Failed"] : "Update Location Failed"}`}
            onClose={handleClosePopup}
            onOpen={handleOpenPopup}
          />
        </>
      </div>
      <div
        className="w-full flex items-center justify-end"
        style={{ marginTop: "24px", gap: "12px" }}
      >
        <div
          onClick={() => {
            webNavigate("/" + preLanguage + "/languages" + "?tab=Languages");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel"}
        </div>
        <div
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#FFFFFF",
            fontSize: "14px",
            fontWeight: "500",
            backgroundColor: "#0F7679",
          }}
          className="font-inter cursor-pointer"
          onClick={(e: any) => {
            handleSubmit(e);
          }}
        >
          <p className="text-[14px] leading-[22px] font-inter">
            {language && language?.["Save"] ? language?.["Save"] : "Save"}
          </p>
        </div>
      </div>
    </>
  );
};
export default CreateLanguage;
